import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

// Definimos el límite máximo de caracteres
const MAX_LENGTH = 1000;

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        message: string().when('is_comment', {
            is: 0,
            then: () =>
                string()
                    .required(REQUIRED_TEXT)
                    .max(
                        MAX_LENGTH,
                        `No puede exceder los ${MAX_LENGTH} caracteres`,
                    ),
            otherwise: () => string().nullable(),
        }),
        note_message: string().when('is_comment', {
            is: 1,
            then: () =>
                string()
                    .required(REQUIRED_TEXT)
                    .max(
                        MAX_LENGTH,
                        `No puede exceder los ${MAX_LENGTH} caracteres`,
                    ),
            otherwise: () => string().nullable(),
        }),
    });
};
